import CustomerProfileColors from './CustomerProfileColors'

export default CustomerProfileColors
